import React from "react";
import { useTheme, Box, Typography } from "@mui/material";

const StatCard = ({ title, value, percentage, icon, iconColor, iconBg, borderColor, textColor }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 3,
        bgcolor: theme.palette.background.paper, // instead of Tailwind bg-white
        borderRadius: 2,
        boxShadow: theme.shadows[3],
        borderLeft: `4px solid ${borderColor || theme.palette.primary.main}`,
        transition: "all 0.3s",
        "&:hover": { boxShadow: theme.shadows[6] },
        width: "100%",
        height: "100%",
      }}
    >
      {/* Left Section */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: theme.palette.text.primary,
            fontFamily: "Nunito Sans, sans-serif",
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          {value}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: textColor || theme.palette.text.secondary,
          }}
        >
          {percentage}
        </Typography>
      </Box>

      {/* Right Section (Icon) */}
      <Box
        sx={{
          width: 56,
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          bgcolor: iconBg || theme.palette.primary.light,
        }}
      >
        {React.cloneElement(icon, {
          sx: { fontSize: 28, color: iconColor || theme.palette.primary.main },
        })}
      </Box>
    </Box>
  );
};

export default StatCard;
